export const loadIsExpectedError = (): Promise<typeof import('./isExpectedError')> =>
  import(
    /* webpackChunkName: "4-feat-is-expected-error" */
    './isExpectedError'
  );
